import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import { NeutralButton, PrimaryButton } from '../casting-styled.component'
import { httpGetAssetPath } from '../../../../services/utils/http.service'
import { formatDurationFromSecs } from '../../../../services/utils/utils.service'

const i18nScoped = new I18nService(require('./casting-enable-lodging-content.component.yml'))

export default function CastingEnableLodgingContentComponent ({ store, data: { market, offeredService } }: StoreProps) {
  const setEnableLodging = React.useCallback((value: boolean) => {
    store.set({ enableLodging: value })
    store.nextFocus()
  }, [store])

  const intro = React.useMemo(() => {
    if (offeredService.service.allowed_lodging_ical_link_mode === 'in_absence_of_guest') {
      return i18nScoped.t('intro_in_absence_of_guest')
    }

    return i18nScoped.t(
      `intro_in_presence_of_guest_${offeredService.lodging_ical_offset < 0 ? 'negative' : 'positive'}_offset_${offeredService.lodging_ical_offset_base}`,
      { offset: formatDurationFromSecs(Math.abs(offeredService.lodging_ical_offset)) }
    )
  }, [offeredService.lodging_ical_offset, offeredService.lodging_ical_offset_base, offeredService.service.allowed_lodging_ical_link_mode])

  return <>
    <p style={{ textAlign: 'justify' }}>{ intro }</p>

    <img style={{ marginTop: '1.5em', width: '100%' }} src={ httpGetAssetPath('interface/ical-lodging-intro.png') } />

    <p style={{ textAlign: 'center', marginBottom: '2em' }}>
      <img src={ market.logo.url } alt="logo" style={{ maxWidth: '10em', maxHeight: '8em' }} />
    </p>

    <PrimaryButton
      style={{ display: 'block', marginTop: '1.5em' }}
      children={ i18nScoped.t('accept') }
      onClick={ () => setEnableLodging(true) } />

    <NeutralButton
      style={{ display: 'block', marginTop: '0.75em' }}
      children={ i18nScoped.t('skip') }
      onClick={ () => setEnableLodging(false) } />
  </>
}
